const STORAGE_KEY = 'REPRO_I18N_SKIP_LOAD_IDIOMA'

/** Solo en desarrollo: simula el fallo del cliente (newSession sin textos + loadIdioma bloqueado). */
export function isI18nReproActive(): boolean {
  return import.meta.env.DEV && localStorage.getItem(STORAGE_KEY) === '1'
}

export function simulateBrokenTextosAfterNewSession<TIdioma, TTextos extends Record<string, string>>(
  idioma: TIdioma,
  textos: TTextos | undefined,
): { idioma: TIdioma; textos: Record<string, never> } | { idioma: TIdioma; textos: TTextos } {
  if (!isI18nReproActive()) {
    return { idioma, textos: textos as TTextos }
  }

  console.warn(
    '[i18n repro] newSession devolvió textos completos pero se simula textos: {} (como el cliente afectado)',
  )
  return { idioma, textos: {} }
}

export function shouldBlockLoadIdioma(): boolean {
  if (!isI18nReproActive()) return false

  console.warn('[i18n repro] loadIdioma bloqueado — el rescate post-login no se ejecutará')
  return true
}

export function registerI18nReproDevTools(): void {
  if (!import.meta.env.DEV) return

  const w = window as Window & {
    __reproI18n?: {
      enable: () => void
      disable: () => void
      status: () => void
    }
  }

  w.__reproI18n = {
    enable() {
      localStorage.setItem(STORAGE_KEY, '1')
      console.info('[i18n repro] ACTIVADO → recarga la página (F5) y abre el menú de usuario')
    },
    disable() {
      localStorage.removeItem(STORAGE_KEY)
      console.info('[i18n repro] DESACTIVADO → recarga la página (F5) para volver a la normalidad')
    },
    status() {
      console.info(`[i18n repro] ${isI18nReproActive() ? 'ACTIVO (verás MSG_xxx)' : 'inactivo'}`)
    },
  }

  if (isI18nReproActive()) {
    console.warn(
      '[i18n repro] Modo activo. Menú con claves MSG_xxx. Desactivar: __reproI18n.disable() + F5',
    )
  } else {
    console.info('[i18n repro] Activar reproducción del bug: __reproI18n.enable() + F5')
  }
}
